import { getInventoryQueryBuilder } from './queries/metrics/inventory-query';
import { getSalesQueryBuilder } from './queries/metrics/sales-query';
import { getOpdQueryBuilder } from './queries/metrics/opd-query';
import {
	replenishtInventoryMetrics,
	replenishmentInventoryMetricsWithDimension,
	replenishmentOPDMetrics,
	replenishmentOPDMetricsWithDimension,
	podInventoryMetricsWithDimension,
	podSalesMetricsWithDimension,
	pricingSalesMetricsWithDimension,
	DIMENSION,
} from './constants';
import { gql } from '@apollo/client';
import { apolloClientWithoutCache } from './apollo';

export const updateRootCauseMetricsQuery = (rootCause, threshold) => {
	if (rootCause === 'inventoryHealth') {
		return buildReplenishmentQuery(threshold);
	} else if (rootCause === 'pod') {
		return buildPodQuery(threshold);
	} else if (rootCause == 'pricing') {
		return buildPricingQuery();
	}
};

/* Buiding the Replenishment Query */
export const buildReplenishmentQuery = (threshold) => {
	const inventoryMetricsQuery = getInventoryQueryBuilder(
		replenishtInventoryMetrics,
		DIMENSION.WM_ITEM_NUMBER,
		true,
		true,
		threshold
	);
	const inventoryMetricsWithDimensionQuery = getInventoryQueryBuilder(
		replenishmentInventoryMetricsWithDimension,
		DIMENSION.WM_ITEM_NUMBER,
		false,
		true,
		threshold
	);
	const opdMetricsQuery = getOpdQueryBuilder(
		replenishmentOPDMetrics,
		DIMENSION.WM_ITEM_NUMBER,
		true
	);
	const opdMetricsWithDimensionQuery = getOpdQueryBuilder(
		replenishmentOPDMetricsWithDimension,
		DIMENSION.WM_ITEM_NUMBER,
		false
	);

	const query = `
        query federatedMetricValues($startDate: String!, $endDate: String!, $ids: [String], $channel: [String]) {
            inventoryWithoutDimension: ${inventoryMetricsQuery}
            inventoryWithDimension: ${inventoryMetricsWithDimensionQuery}
            opdWithoutDimension: ${opdMetricsQuery}
            opdMetricsWithDimension: ${opdMetricsWithDimensionQuery}
        }
    `;
	return query;
};

/* Buiding the POD Query */
export const buildPodQuery = (threshold) => {
	const salesWithDimensionQuery = getSalesQueryBuilder(
		podSalesMetricsWithDimension,
		DIMENSION.WM_ITEM_NUMBER
	);
	const inventoryWithDimensionQuery = getInventoryQueryBuilder(
		podInventoryMetricsWithDimension,
		DIMENSION.WM_ITEM_NUMBER,
		false,
		false,
		threshold
	);

	const query = `
        query federatedMetricValues($startDate: String!, $endDate: String!, $ids: [String], $channel: [String]) {
            salesWithDimension: ${salesWithDimensionQuery}
            inventoryWithDimension: ${inventoryWithDimensionQuery}
        }
    `;
	return query;
};

/* Building the Pricing Query */
export const buildPricingQuery = () => {
	const salesWithDimensionQuery = getSalesQueryBuilder(
		pricingSalesMetricsWithDimension,
		DIMENSION.WM_ITEM_NUMBER
	);
	const query = `
        query federatedMetricValues($startDate: String!, $endDate: String!, $ids: [String], $channel: [String]) {
            salesWithDimension: ${salesWithDimensionQuery}
        }
    `;
	return query;
};

export const updateFederatedMetricsQuery = (rootCause, payload, threshold) => {
	const queryStr = updateRootCauseMetricsQuery(rootCause, threshold);
	const query = gql`
		${queryStr}
	`;
	return apolloClientWithoutCache.query({
		query,
		context: {
			headers: {
				'x-Apollo-operation-name': 'federatedMetricValues',
			},
		},
		variables: payload,
	});
};
